import {AxiosError} from 'axios';
import {useQuery, UseQueryOptions} from '@tanstack/react-query';

import {api} from '@eksab/api';

import type {CoinsPackage} from '@eksab/features/store/types';
import {useAccessToken} from '@eksab/hooks';

type QueryContext = 'user' | 'guest';

const queryKey = (context: QueryContext = 'guest') => ['packages', context];

const queryFn = (isLoggedIn: boolean) => {
  return api.get<{data: CoinsPackage[]}>(isLoggedIn ? 'v3/packages/auth' : 'v3/packages').then((res) => res.data.data);
};
export function usePackagesQuery(options?: UseQueryOptions<CoinsPackage[], AxiosError>) {
  const isLoggedIn = useAccessToken().isSuccess;

  return useQuery<CoinsPackage[], AxiosError>(
    queryKey(isLoggedIn ? 'user' : 'guest'),
    () => queryFn(isLoggedIn),
    options,
  );
}

usePackagesQuery.queryFn = queryFn;
usePackagesQuery.queryKey = queryKey;
